import {
  addProduct,
  createMultipleProductAlias,
  createMultipleProductCategories,
  createMultipleProductPlan,
  createMultipleProducts,
  createMultipleProductTags,
  createProductAlias,
  createProductCategory,
  createProductTag,
  getDownloadedProductAlias,
  getDownloadedProductCategories,
  getDownloadedProductPlans,
  getDownloadedProducts,
  getDownloadedProductTags,
  getProductAcquisitionCode,
  getProductAlias,
  getProductAliasFields,
  getProductBasedWareCosting,
  getProductCategories,
  getProductCategoryFields,
  getProductFields,
  getProductOrderFrequency,
  getProductPlanFields,
  getProductPlanningPolicy,
  getProductPlans,
  getProductReOrderPlanMethod,
  getProducts,
  getProductsBasedFromWarehouse,
  getProductsBasedSupplier,
  getProductStatus,
  getProductStockLocation,
  getProductStorageMethod,
  getProductTags,
  getProductTagsFields,
  getProductType,
  setPacks,
  setProductAliasSelection,
  setProductCategoriesSelection,
  setProductsSelection,
  setProductTagsSelection,
  updateMultipleProductAlias,
  updateMultipleProductCategories,
  updateMultipleProductPlans,
  updateMultipleProducts,
  updateMultipleProductTags,
  updateProduct,
  updateProductAlias,
  updateProductCategory,
  updateProductPlan,
  updateProductTag,
} from "../slice/productSlice";
import { apiSlice } from "./apiSlice";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createMultipleProductAlias: builder.mutation({
      query: data => ({
        url: "/api_product/product_alias/create_multiple_product_alias/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleProductAlias(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleProductCategories: builder.mutation({
      query: data => ({
        url: "/api_product/product_category/create_multiple_produt_category/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleProductCategories(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleProductPlans: builder.mutation({
      query: data => ({
        url: "/api_product/product_plan/create_multiple_product_plans/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleProductPlan(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleProducts: builder.mutation({
      query: data => ({
        url: "/api_product/product/create_multiple_produts/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleProducts(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleProductTags: builder.mutation({
      query: data => ({
        url: "/api_product/product_tag/create_multiple_produt_tag/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleProductTags(result.data.data)))
          .catch(error => {});
      },
    }),
    createPack: builder.mutation({
      query: data => ({ url: "/api_product/pack/", method: "POST", body: data }),
    }),
    createProduct: builder.mutation({
      query: data => ({ url: "/api_product/product/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(addProduct(result.data))).catch(error => {});
      },
    }),
    createProductAlias: builder.mutation({
      query: data => ({
        url: "/api_product/product_alias/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createProductAlias(result.data))).catch(error => {});
      },
    }),
    createProductCategory: builder.mutation({
      query: data => ({
        url: "/api_product/product_category/create_product_category/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createProductCategory(result.data.data)))
          .catch(error => {});
      },
    }),
    createProductCategoryV2: builder.mutation({
      query: data => ({
        url: "/api_product/product_category/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createProductCategory(result.data.data)))
          .catch(error => {});
      },
    }),
    createProductPlan: builder.mutation({
      query: data => ({
        url: "/api_product/product_plan/",
        method: "post",
        body: data,
      }),
      invalidatesTags: ["ProductPlan"],
    }),
    createProductTag: builder.mutation({
      query: data => ({
        url: "/api_product/product_tag/",
        method: "post",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createProductTag(result.data))).catch(error => {});
      },
    }),
    editProduct: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/api_product/product/${id}/`,
        method: "put",
        body: payload,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateProduct(result.data.data))).catch(error => {});
      },
    }),
    getDownloadedProductAlias: builder.query({
      query: params =>
        params
          ? `/api_product/product_alias/download_records/?${params}`
          : "/api_product/product_alias/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedProductAlias(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedProductCategories: builder.query({
      query: params =>
        params
          ? `/api_product/product_category/download_records/?${params}`
          : "/api_product/product_category/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedProductCategories(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedProductPlans: builder.query({
      query: params =>
        params
          ? `/api_product/product_plan/download_records/?${params}`
          : "/api_product/product_plan/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedProductPlans(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedProducts: builder.query({
      query: params =>
        params
          ? `/api_product/product/download_records/?${params}`
          : "/api_product/product/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedProducts(result.data.data)))
          .catch(error => {});
      },
    }),
    getDownloadedProductTags: builder.query({
      query: params =>
        params
          ? `/api_product/product_tag/download_records/?${params}`
          : "/api_product/product_tag/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedProductTags(result.data.data)))
          .catch(error => {});
      },
    }),
    getLeadTimeBasedFromWarehouse: builder.query({
      query: params => `/api_product/get_leades_from_warehouse/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => {}).catch(error => {});
      },
    }),
    getLeadTimeBasedProdSuppWare: builder.query({
      query: params => `/api_product/get_product_lead/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => {}).catch(error => {});
      },
    }),
    getPacks: builder.query({
      query: (params = null) => (params ? `/api_product/pack/?${params}` : "/api_product/pack/"),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setPacks(result.data))).catch(error => {});
      },
    }),
    getPackById: builder.query({
      query: id => ({
        url: `/api_product/pack/${id}/`,
      }),
    }),
    getProductAcquisitionCode: builder.query({
      query: () => "/api_product/product_acquisition/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductAcquisitionCode(result.data)))
          .catch(error => {});
      },
    }),
    getProductAlias: builder.query({
      query: (params = null) =>
        params ? `/api_product/product_alias/?${params}` : "/api_product/product_alias/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductAlias(result.data))).catch(error => {});
      },
    }),
    getProductAliasById: builder.query({
      query: id => ({
        url: `/api_product/product_alias/${id}/`,
      }),
    }),
    getProductAliasSelection: builder.query({
      query: () => `/api_product/product_alias/selection`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductAliasSelection(result.data)))
          .catch(error => {});
      },
    }),
    getProductAliasFields: builder.query({
      query: () => "/api_product/product_alias_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductAliasFields(result.data)))
          .catch(error => {});
      },
    }),
    getProductBundleItems: builder.query({
      query: (params = null) =>
        params ? `/api/product/v1/bundle_item/?${params}` : "/api/product/v1/bundle_item/",
    }),
    getProductBasedWareCosting: builder.query({
      query: (params = null) => `/api_product/get_products_warehouse_costing`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductBasedWareCosting(result.data.data)))
          .catch(error => {});
      },
    }),
    getProductCategories: builder.query({
      query: (params = null) =>
        params ? `/api_product/product_category/?${params}` : "/api_product/product_category/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductCategories(result.data)))
          .catch(error => {});
      },
    }),
    getProductCategoryById: builder.query({
      query: id => ({
        url: `/api_product/product_category/${id}/`,
      }),
    }),
    getProductCategoriesSelection: builder.query({
      query: params => ({
        url: "/api_product/product_category/selection",
        params,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductCategoriesSelection(result.data)))
          .catch(error => {});
      },
    }),
    getProductCategoryFields: builder.query({
      query: () => "/api_product/product_category_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductCategoryFields(result.data)))
          .catch(error => {});
      },
    }),
    getProductFields: builder.query({
      query: () => "/api_product/product_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductFields(result.data))).catch(error => {});
      },
    }),
    getProductForUpdate: builder.query({
      providesTags: ["Product"],
      query: id => `/api_product/product/${id}/retrieve_for_update/`,
    }),
    getProductOrderFrequency: builder.query({
      query: () => "/api_product/product_order_frequency/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductOrderFrequency(result.data)))
          .catch(error => {});
      },
    }),
    getProductPlanFields: builder.query({
      query: () => "/api_product/product_plan_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductPlanFields(result.data)))
          .catch(error => {});
      },
    }),
    getProductPlanningPolicy: builder.query({
      query: () => "/api_product/product_planning_policy/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductPlanningPolicy(result.data)))
          .catch(error => {});
      },
    }),
    getProductPlans: builder.query({
      query: (params = null) =>
        params ? `/api_product/product_plan/?${params}` : "/api_product/product_plan/",
      providesTags: ["ProductPlan"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductPlans(result.data))).catch(error => {});
      },
    }),

    getProductPlanById: builder.query({
      query: id => ({
        url: `/api_product/product_plan/${id}/`,
      }),
    }),
    getProductReOrderPlanMethod: builder.query({
      query: () => "/api_product/product_re_order/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductReOrderPlanMethod(result.data)))
          .catch(error => {});
      },
    }),
    getProducts: builder.query({
      providesTags: ["Product"],
      query: (params = null) =>
        params ? `/api_product/product/?${params}` : "/api_product/product/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProducts(result.data))).catch(error => {});
      },
    }),
    getProductsByWarehouse: builder.query({
      query: (id = null) => `/api_product/product/stock/?warehouse_id=${id}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProducts(result.data))).catch(error => {});
      },
    }),
    getProductsBasedFromWarehouse: builder.query({
      providesTags: ["ProductWarehouseCosting"],
      query: params => `/api_product/get_products_from_warehouse/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductsBasedFromWarehouse(result.data)))
          .catch(error => {});
      },
    }),
    getProductsBasedSupplier: builder.query({
      providesTags: ["ProductWarehouseCosting"],
      query: params => `/api_product/get_products_from_warehouse/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductsBasedSupplier(result.data)))
          .catch(error => {});
      },
    }),
    getProductsWithCategory: builder.query({
      query: params => ({
        url: "/api_product/product/selection_with_catg/",
        params,
      }),
    }),
    getProductsSelection: builder.query({
      providesTags: ["Product"],
      query: (arg = null) => {
        const queryStr = typeof arg === "string" ? arg : arg?.params;
        return queryStr
          ? `/api_product/product/?type=selection&${queryStr}`
          : "/api_product/product/?type=selection";
      },
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductsSelection(result.data)))
          .catch(error => {});
      },
    }),
    getProductStatus: builder.query({
      query: () => "/api_product/product_status/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductStatus(result.data))).catch(error => {});
      },
    }),
    getProductStockLocation: builder.query({
      query: () => "/api_product/product_stock_location/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductStockLocation(result.data)))
          .catch(error => {});
      },
    }),
    getProductStorageMethod: builder.query({
      query: () => "/api_product/product_storage_method/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductStorageMethod(result.data)))
          .catch(error => {});
      },
    }),
    getProductTags: builder.query({
      query: (params = null) =>
        params ? `/api_product/product_tag/?${params}` : "/api_product/product_tag/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductTags(result.data))).catch(error => {});
      },
    }),
    getProductTagById: builder.query({
      query: id => ({
        url: `/api_product/product_tag/${id}/`,
      }),
    }),
    getProductTagsFields: builder.query({
      query: () => "/api_product/product_tags_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getProductTagsFields(result.data)))
          .catch(error => {});
      },
    }),
    getProductTagsSelection: builder.query({
      query: () => "/api_product/product_tag/selection/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setProductTagsSelection(result.data)))
          .catch(error => {});
      },
    }),
    getProductType: builder.query({
      query: () => "/api_product/product_type/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getProductType(result.data))).catch(error => {});
      },
    }),
    getProductUnitPrice: builder.query({
      providesTags: ["Product"],
      query: params => `/api_product/get_unit_price/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => {}).catch(error => {});
      },
    }),

    updateMultipleProductAlias: builder.mutation({
      query: data => ({
        url: "/api_product/product_alias/update_downloaded_product_alias/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleProductAlias(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleProductCategories: builder.mutation({
      query: data => ({
        url: "/api_product/product_category/update_downloaded_product_categories/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleProductCategories(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleProductPlans: builder.mutation({
      query: data => ({
        url: "/api_product/product_plan/update_downloaded_product_plans/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleProductPlans(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleProducts: builder.mutation({
      query: data => ({
        url: "/api_product/product/update_downloaded_products/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleProducts(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleProductTags: builder.mutation({
      query: data => ({
        url: "/api_product/product_tag/update_downloaded_product_tag/",
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleProductTags(result.data.data)))
          .catch(error => {});
      },
    }),
    updatePack: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_product/pack/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),
    updateProductAlias: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_product/product_alias/${id}/`,
        method: "PUT",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateProductAlias(result.data))).catch(error => {});
      },
    }),
    updateProductCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_product/product_category/${id}/update_product_category/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateProductCategory(result.data.data)))
          .catch(error => {});
      },
    }),
    updateProductCategoryV2: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_product/product_category/${id}/`,
        method: "PUT",
        body: data,
      }),
    }),
    updateProductPlan: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/api_product/product_plan/${id}/`,
        method: "put",
        body: payload,
      }),
      invalidatesTags: ["ProductPlan"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateProductPlan(result.data))).catch(error => {});
      },
    }),
    getProductPlanHistory: builder.query({
      query: ({ id, limit, offset } = {}) => {
        const params = new URLSearchParams({
          ...(limit && { limit }),
          ...(offset && { offset }),
        });
        return `/api_product/product_plan/${id}/history/?${params.toString()}`;
      },
    }),
    updateProductTag: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_product/product_tag/${id}/`,
        method: "PUT",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateProductTag(result.data))).catch(error => {});
      },
    }),
  }),
});

export const {
  useCreateMultipleProductAliasMutation,
  useCreateMultipleProductCategoriesMutation,
  useCreateMultipleProductPlansMutation,
  useCreateMultipleProductsMutation,
  useCreateMultipleProductTagsMutation,
  useCreatePackMutation,
  useCreateProductAliasMutation,
  useCreateProductCategoryMutation,
  useCreateProductCategoryV2Mutation,
  useCreateProductMutation,
  useCreateProductPlanMutation,
  useCreateProductTagMutation,
  useEditProductMutation,
  useGetPacksQuery,
  useGetPackByIdQuery,
  useGetProductAcquisitionCodeQuery,
  useGetProductAliasByIdQuery,
  useGetProductAliasFieldsQuery,
  useGetProductAliasQuery,
  useGetProductBasedWareCostingQuery,
  useGetProductBundleItemsQuery,
  useGetProductCategoriesQuery,
  useGetProductCategoryByIdQuery,
  useGetProductCategoriesSelectionQuery,
  useLazyGetProductCategoriesSelectionQuery,
  useGetProductCategoryFieldsQuery,
  useGetProductFieldsQuery,
  useGetProductForUpdateQuery,
  useGetProductOrderFrequencyQuery,
  useGetProductPlanFieldsQuery,
  useGetProductPlanningPolicyQuery,
  useGetProductPlansQuery,
  useGetProductPlanByIdQuery,
  useGetProductPlanHistoryQuery,
  useGetProductReOrderPlanMethodQuery,
  useGetProductsQuery,
  useGetProductsByWarehouseQuery,
  useGetProductsSelectionQuery,
  useGetProductStatusQuery,
  useGetProductStockLocationQuery,
  useGetProductStorageMethodQuery,
  useGetProductTagsFieldsQuery,
  useGetProductTagsQuery,
  useGetProductTagsSelectionQuery,
  useGetProductTagByIdQuery,
  useGetProductTypeQuery,
  useGetProductsWithCategoryQuery,
  useLazyGetDownloadedProductAliasQuery,
  useLazyGetDownloadedProductCategoriesQuery,
  useLazyGetDownloadedProductPlansQuery,
  useLazyGetDownloadedProductsQuery,
  useLazyGetProductAliasSelectionQuery,
  useLazyGetDownloadedProductTagsQuery,
  useLazyGetLeadTimeBasedFromWarehouseQuery,
  useLazyGetLeadTimeBasedProdSuppWareQuery,
  useLazyGetProductCategoriesQuery,
  useLazyGetProductsBasedFromWarehouseQuery,
  useLazyGetProductsBasedSupplierQuery,
  useLazyGetProductsSelectionQuery,
  useLazyGetProductTagsSelectionQuery,
  useLazyGetProductUnitPriceQuery,
  useUpdateMultipleProductAliasMutation,
  useUpdateMultipleProductCategoriesMutation,
  useUpdateMultipleProductPlansMutation,
  useUpdateMultipleProductsMutation,
  useUpdateMultipleProductTagsMutation,
  useUpdatePackMutation,
  useUpdateProductAliasMutation,
  useUpdateProductCategoryMutation,
  useUpdateProductCategoryV2Mutation,
  useUpdateProductPlanMutation,
  useUpdateProductTagMutation,
} = productApiSlice;
